import axios from '@/plugin/axios';
import Routes from './routes';

const getSubscriptions = () => axios.get(Routes.subscriptions);

export const renewOrganizationSubscription = (organizationId, payload) =>
  axios.post(`/organizations/${organizationId}/renew_subscription/`, payload);

export const cancelOrganizationSubscription = (organizationId) =>
  axios.delete(`/organizations/${organizationId}/cancel_subscription/`);

export default getSubscriptions;
